module.exports = "$content = <talk:list />;\nforeach ($talks as $talk) {\n  $content->appendChild(<talk talk={$talk} />);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/xhp.example
// module id = 1492
// module chunks = 0